// extracted by mini-css-extract-plugin
export default {"logo":"questionnaire_logo__QXAjR","main":"questionnaire_main__6z2GA","message":"questionnaire_message__-lcgM","line":"questionnaire_line__kuI1L"};